import React from "react";
import { Select } from "antd";

import { Icons } from "components/layout";
import { Localize } from "components/service";

const { Option } = Select;

const DamageStatusSelectField = ({ ...props }) => {
    return (
        <Select
            className="damage-status-select-field"
            suffixIcon={<Icons.Arrow type="filled" />}
            defaultValue={null}
            { ...props }
        >
            <Option value={null}>
                <Localize>FORMS.Select_DefaultValue_All</Localize>
            </Option>
            <Option value="new">
                <Localize>DAMAGE.Status_Label_New</Localize>
            </Option>
            <Option value="check">
                <Localize>DAMAGE.Status_Label_Check</Localize>
            </Option>
            <Option value="double_check">
                <Localize>DAMAGE.Status_Label_DCheck</Localize>
            </Option>
        </Select>
    );
};

export default DamageStatusSelectField;
